const { createContext, useState, useContext } = require("react");

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {

  const [selectedLanguage, setSelectedLanguage] = useState("ita");
  const changeLanguage = () => setSelectedLanguage(prevState => (prevState === "ita" ? "en" : "ita"));
  const contextValue = { selectedLanguage, changeLanguage };

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (ctx) {
    return ctx;
  } else {
    throw new Error("LanguageContext must be used within its own Provider.");
  }
};